module.exports = __webpack_public_path__ + "img/swift-sportForm.52dd48b5.svg";